class d extends HTMLElement {
  constructor() {
    super(), this.query = this.getAttribute("query"), this.sectionId = this.getAttribute("id"), this.productId = this.getAttribute("current-product-id");
  }
  connectedCallback() {
    this.query && this.getRelatedProducts();
  }
  getRelatedProducts() {
    fetch(`/search?q=${this.query}&section_id=related-products`).then((e) => e.text()).then((e) => {
      const t = new DOMParser().parseFromString(e, "text/html").querySelector(
        "#related-products"
      );
      if (t) {
        const r = t.querySelector(
          `[data-product-id="${this.productId}"]`
        );
        r && r.remove(), t.querySelectorAll(
          "[data-product-id]"
        ).length ? this.removeAttribute("data-empty") : this.setAttribute("data-empty", ""), this.setAttribute("data-loaded", ""), this.innerHTML = t.innerHTML || "", this.setAttribute("data-loaded", "");
      }
    }).catch(() => {
      console.error("Error fetching related products");
    });
  }
}
customElements.define("related-products", d);
export {
  d as RelatedProducts
};
